import { Button, Tooltip } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import useExport from "../../hooks/comms/useExport";

interface Props {
    reportId: number;
}

const ButtonDownloadReport = ({ reportId = 3 }: Props) => {
    const { exportExcel, downloading } = useExport();
    const { t } = useTranslation();

    const handleDownload = async () => {
        const url = `/comms/download-report-imports/${reportId}`;
        await exportExcel(url, {}, '', 'get');
    };

    return (
        <Tooltip title={t('exportExcel')}>
            <Button
                shape='circle'
                icon={<DownloadOutlined />}
                onClick={handleDownload}
                loading={downloading}
                type='primary'
            />
        </Tooltip>
    );
};

export default ButtonDownloadReport;
